import type { Product } from '../useCheckoutForm';

/** 28 → « 28 € », 28.5 → « 28,50 € » (espace fine insécable avant €). */
export function formatAmount(value: number): string {
  const n = Number.isFinite(value) ? value : 0;
  const text = Number.isInteger(n) ? String(n) : n.toFixed(2).replace('.', ',');
  return `${text}\u00A0€`;
}

export function sessionsLabel(count: number | undefined): string | null {
  if (!count || count <= 0) return null;
  return count === 1 ? '1 séance' : `${count} séances`;
}

export function validityLabel(product: Product): string | null {
  if (product.type !== 'service') return null;
  const length = product.ExpirationLength;
  const unit = product.ExpirationUnit;
  if (!length || !unit) return null;
  if (unit === 'Days') return `Valable ${length} jour${length > 1 ? 's' : ''}`;
  return `Valable ${length} mois`;
}

export function recurringLabel(product: Product): string | null {
  if (product.type !== 'contract') return null;
  const unit = product.AutopaySchedule?.FrequencyTimeUnit;
  const value = product.AutopaySchedule?.FrequencyValue ?? 1;
  const amount = product.RecurringPaymentAmountTotal;
  if (!amount) return null;
  const per =
    unit === 'Monthly' ? (value > 1 ? `${value} mois` : 'mois')
    : unit === 'Weekly' ? (value > 1 ? `${value} semaines` : 'semaine')
    : unit === 'Yearly' ? 'an'
    : unit === 'Daily' ? 'jour'
    : null;
  return per ? `puis ${formatAmount(amount)} / ${per}` : null;
}

export function engagementLabel(product: Product): string | null {
  if (product.type !== 'contract') return null;
  const n = product.NumberOfAutopays;
  const unit = product.AutopaySchedule?.FrequencyTimeUnit;
  if (!n || n <= 1) return 'Sans engagement';
  if (unit === 'Monthly') return `Engagement ${n} mois`;
  return `${n} prélèvements`;
}

export function productTitle(product: Product): string {
  if (product.type === 'giftcard') return product.Name || product.Description || 'Carte cadeau';
  return product.Name;
}
